import { useState, useEffect } from "react";
import { useChartPie } from "../../hooks";

export default function Module_Diabetes_HighBloodSugar({
  moduleTitle = "",
  moduleData = {},
  apiData = [],
  exportData = [],
  callMainAPI = () => null,
}) {
  const { renderPie } = useChartPie({
    setting: moduleData,
    isExportRawList: true,
  });
  const [chartData, setChartData] = useState({ raw: [], format: [] });

  useEffect(() => {
    if (!apiData) return;
    setChartData({
      raw: exportData,
      format: apiData,
      export: null,
    });
  }, [apiData, exportData]);

  return (
    <>
      <div className="w-full overflow-auto">
        {renderPie({
          moduleTitle,
          options: {
            moduleData,
            chartData,
            callMainAPI,
          },
        })}
      </div>
    </>
  );
}
